import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionCoopXpHighScoresNameRequest, actionCoopXpHighScoresPositionRequest, TypeActionRanking, } from "../actionRanking";
export var epicCoopXpRanking = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionRanking.CoopXpRankingRequest), switchMap(function (action) {
        return action.nameSearch
            ? of(actionCoopXpHighScoresNameRequest(action.nameSearch))
            : of(actionCoopXpHighScoresPositionRequest(action.position || 1));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/epics/epicCoopXpRanking.ts
// module id = 2117
// module chunks = 3